import React from 'react';

export default function IconWatchlist() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M13.4658 2.68632L16.3339 8.52652L22.7769 9.4514C23.2029 9.51375 23.3692 10.0333 23.0678 10.3347L18.4019 14.8759L19.5138 21.2877C19.5866 21.7137 19.1397 22.0359 18.7552 21.8384L12.9982 18.804L7.24109 21.8384C6.85659 22.0359 6.40974 21.7137 6.48249 21.2877L7.59441 14.8759L2.92848 10.3347C2.61673 10.0333 2.79339 9.51375 3.21946 9.4514L9.66238 8.52652L12.5305 2.68632C12.7176 2.30182 13.2683 2.30182 13.4658 2.68632Z"
      />
    </svg>
  );
}
